
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface AdminAuthGuardProps {
  children: React.ReactNode;
}

const AdminAuthGuard = ({ children }: AdminAuthGuardProps) => {
  const { user, isAdmin, loading, authChangeProcessed, roleLoadError } = useAuth();

  if (loading || !authChangeProcessed) {
    return (
      <div className="min-h-screen bg-warm-cream flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-4 border-b-transparent border-peach-orange rounded-full" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Role fetch failed — show an error rather than silently redirecting the user
  if (roleLoadError) {
    return (
      <div className="min-h-screen bg-warm-cream flex items-center justify-center">
        <div className="text-center space-y-4 p-8">
          <p className="text-sunset-dark font-medium">Could not verify your admin access.</p>
          <p className="text-sm text-muted-foreground">This is usually a temporary network issue.</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-peach-orange text-white rounded-md text-sm font-medium hover:bg-peach-orange/90 transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminAuthGuard;
